@if (step() !== 'idle') {
  <div class="reject-flow-backdrop" role="presentation">
    <div
      class="reject-flow-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="
        (step() === 'confirm'
          ? 'AgentDesktop::Telephony:Decline'
          : 'AgentDesktop::Telephony:RejectedCall') | abpLocalization
      "
    >
      @if (callerLabel(); as caller) {
        <p class="reject-flow-caller">
          <i class="pi pi-phone" aria-hidden="true"></i>
          <span>{{ caller }}</span>
        </p>
      }

      @if (step() === 'confirm') {
        <h3 class="reject-flow-title">
          {{ 'AgentDesktop::Telephony:Decline' | abpLocalization }}
        </h3>
        <p class="reject-flow-text">
          {{ 'AgentDesktop::Telephony:DeclineConfirmQuestion' | abpLocalization }}
        </p>
        <div class="reject-flow-actions">
          <button
            type="button"
            class="reject-flow-btn reject-flow-btn-secondary"
            (click)="onCancel()"
          >
            {{ 'AgentDesktop::Telephony:No' | abpLocalization }}
          </button>
          <button
            type="button"
            class="reject-flow-btn ad-call-action-decline reject-flow-btn-danger"
            [disabled]="busy()"
            (click)="onProceedToReasonSelection()"
          >
            {{ 'AgentDesktop::Telephony:Yes' | abpLocalization }}
          </button>
        </div>
      }

      @if (step() === 'reason') {
        <h3 class="reject-flow-title">
          {{ 'AgentDesktop::Telephony:RejectedCall' | abpLocalization }}
        </h3>
        <p class="reject-flow-text">
          {{ 'AgentDesktop::Telephony:SelectDeclineReason' | abpLocalization }}
        </p>

        <div
          class="reject-reason-list"
          role="listbox"
          [attr.aria-label]="'AgentDesktop::Telephony:SelectDeclineReason' | abpLocalization"
        >
          @for (reason of reasonOptions(); track reason.value) {
            <button
              type="button"
              class="reject-reason-btn"
              [class.reject-reason-btn-active]="selectedReason() === reason.value"
              (click)="onSelectReason(reason.value)"
            >
              {{ reason.label }}
            </button>
          }
        </div>

        <div class="reject-flow-actions">
          <button
            type="button"
            class="reject-flow-btn reject-flow-btn-secondary"
            (click)="onCancel()"
          >
            {{ 'AgentDesktop::Telephony:No' | abpLocalization }}
          </button>
          <button
            type="button"
            class="reject-flow-btn ad-call-action-decline reject-flow-btn-danger"
            [disabled]="!selectedReason() || busy()"
            (click)="onConfirmReject()"
          >
            {{ 'AgentDesktop::Telephony:Confirm' | abpLocalization }}
          </button>
        </div>
      }
    </div>
  </div>
}
